import Api from './Api'
import { API_VERSION } from '@/config/index'

export default {

  GetUsers(payload) {
    return Api().get(`/admin/user`, { params: payload })
  },
  GetUsersByType(payload, params) {
    return Api().get(`/admin/user/all-by-type/${payload.user_type_key}`, { params })
  },
  GetUser(payload) {
    return Api().get(`/admin/user/single/${payload.user_id}`, payload)
  },
  Login(payload) {
    return Api().post(`/login`, payload)
  },
  AddEditUser(payload) {
    return Api().post(`/admin/user/add-edit-user`, payload)
  },
  GetUserTypes() {
    return Api().get(`/admin/user/user-types`)
  },
}



// WEBPACK FOOTER //
// ./src/apiServices/UserService.js